// Pure helpers for the refund queue — kept JSX-free so vitest can import them
// (the component itself only compiles under the webpack/babel build).

// Mirrors the engine's DEFAULT_BEARER (refundPolicy.js): who pays when the
// approver does not override.
const DEFAULT_BEARER_BY_REASON = {
    ITEM_MISSING: 'shop', ITEM_WRONG: 'shop', ITEM_QUALITY: 'shop',
};

export const BEARER_LABELS = {
    shop: 'Shop (items)',
    driver: 'Driver (delivery fee)',
    platform: 'Platform (goodwill)',
};

export function defaultBearerFor(reasonCode) {
    return DEFAULT_BEARER_BY_REASON[reasonCode] || 'platform';
}

export function formatIDR(amount) {
    if (amount == null) return '—';
    return 'Rp ' + Number(amount).toLocaleString('id-ID');
}

/**
 * What approving WITHOUT an override will actually charge. A saved proposal
 * (allocation legs on the request) takes precedence over the reason-code
 * default — the engine restores stored legs at approval, so showing the
 * reason default for a shop-funded GOODWILL proposal (or vice versa) would
 * mislead the approver into charging the wrong party.
 */
export function effectiveDefaultLabel(row, reasonCode) {
    const legs = row && row.allocations;
    if (legs && legs.length === 1) {
        return `Proposed: ${BEARER_LABELS[legs[0].bearer] || legs[0].bearer}`;
    }
    if (legs && legs.length > 1) {
        const split = legs.map((leg) => `${leg.bearer} ${formatIDR(leg.amount)}`).join(' · ');
        return `Proposed split: ${split}`;
    }
    const fallback = defaultBearerFor(reasonCode);
    return `Default for ${reasonCode || 'reason'}: ${BEARER_LABELS[fallback]}`;
}
